import { useEffect, useState } from 'react';

interface UseCountUpOptions {
  target: number;
  durationMs?: number;
  startDelayMs?: number;
}

export function useCountUp({ target, durationMs = 950, startDelayMs = 0 }: UseCountUpOptions): number {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let rafId: number | null = null;
    let startTime: number | null = null;

    const tick = (now: number) => {
      if (startTime === null) startTime = now;
      const elapsed = now - startTime;
      const t = Math.min(1, elapsed / durationMs);
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(target * eased);
      if (t < 1) {
        rafId = requestAnimationFrame(tick);
      }
    };

    const timeoutId = window.setTimeout(() => {
      rafId = requestAnimationFrame(tick);
    }, startDelayMs);

    return () => {
      window.clearTimeout(timeoutId);
      if (rafId !== null) cancelAnimationFrame(rafId);
    };
  }, [target, durationMs, startDelayMs]);

  return value;
}
